const enumValue = description => Object.freeze({
    toString: () => description
});

export const ID = enumValue("ID");
export const NAME = enumValue("NAME");
export const EMAIL = enumValue("EMAIL");
export const COMPANY = enumValue('COMPANY');
export const NO_SORT = enumValue('');